/**
 * stateHelper.js
 * Created by michaelbray on 2/14/18.
 */

export function cloneState(state) {
    return JSON.parse(JSON.stringify(state));
}
